/**
 * Audio.js
 */
import Plyr from 'plyr';

const audioPlayerObject = {
    solo: null,
    playlist: null
  };
  
  /***************************************************************************************************************
   * AUDIO
   ***************************************************************************************************************/
  const AUDIO = (() => {
    const _off = null;
    let _watchEnd = false;
    let _watchEndnextId = null;
    let _audioEmpty;
    let _audioPlayerHandler;
    let _removeLoading;
    let _loadingView = false;
    let _loadedFlg = false;
    let _hideloading = false;
    let _loading;
    let _setWait;
    let _playSpeed = 1.0;
  
  
    // for web audio api
    let audioContext = window.AudioContext || window.webkitAudioContext;
  
  
    /**
     * 音声・動画の再生中止
     * 
     * @param {requestCallback} callback - 音声・動画の再生中止後の処理
     */
    const __destoryMedia = callback => {
  
        if(audioPlayerObject.solo) {
            audioPlayerObject.solo.stop();
        }
  
        if (callback) {
            __initplayAudio({ soundPath: null, destorycallback: callback });
        } else {
            __initplayAudio({ soundPath: null });
        }
    };
    /**
     * 音声・動画の再生中止
     * 
     * @param {requestCallback} callback - 音声・動画の再生中止後の処理
     */
    const __destoryMediaSerial = callback => {
        if (callback) {
            __initplayAudioSerial({ soundPath: null, destorycallback: callback });
        } else {
            __initplayAudioSerial({ soundPath: null });
        }
    };
  
    /**
     * clearInterval
     * 
     * @param {*} value 
     */
    const __clearInterval = value => {
        if (value) clearInterval(value);
    };
  
    /**
     * clearTimeout
     * 
     * @param {*} value 
     */
    const __clearTimeout = value => {
        if (value) clearTimeout(value);
    };
  
    /**
     * Check Intervalを入れる
     * 
     * @param {function} func 
     * @param {Object} variable 
     * @param {number} checkTime 
     * @param {number} allClearTime 
     */
    const __checkInterval = (variable, func, checkTime, allClearTime) => {
        __clearInterval(variable);
        setTimeout(() => {
            __clearInterval(variable);
        }, allClearTime);
        return setInterval(func, checkTime);
    };
  
    /**
     * 500ms以内に音声がロードできない場合表示
     * ３秒後ロードのままだとローディングを非表示する
     */
    const __loadingTimeout = () => {
        __clearTimeout(_loading);
        _loading = setTimeout(() => {
            if (!_loadedFlg) {
                L.showLoading();
                _loadingView = true;
            }
        }, 500);
  
        setTimeout(() => {
            L.hideLoading();
        }, 3000);
    };
  
    /**
     * プレイヤー初期化
     * 
     * @param {Object} data 
     */
    var __initplayAudio = data => {
  
        const isFirstTouch = false;
        _loadedFlg = false;
  
        if(data.noLoading !== undefined && data.noLoading) {
          _hideloading = true;
        }
  
        if (data.soundPath) {
  
            _audioPlayerHandler = () => {
                L.hideLoading();
                if(!_hideloading) __loadingTimeout();
  
                const _assetsPath = `${L.getPublicPath()}assets/`;
                
                if(! (audioPlayerObject.solo && audioPlayerObject.solo.ready)) {
                    audioPlayerObject.solo = new Plyr('#audio_player', {
                        blankVideo: `${_assetsPath}images/video/blank.mp3`,
                        controls: [],
                        hideControls: true,
                        clickToPlay: false,
                        resetOnEnd: true,
                        autoplay: false,
                        autopause: true,
                        storage: { enabled: false}
                    });
                }
  
                audioPlayerObject.solo.source = {
                    type: 'audio',
                    sources: [
                        {
                            src: data.soundPath,
                            type: 'audio/mp3'
                        }
                    ]
                };
  
                // speedを再設定
                __setSpeed(COMP.PLAYOPTION.getSpeed());
  
                let loadedEvent = false;
  
                audioPlayerObject.solo.on('ready', event => {
  
                    audioPlayerObject.solo.on('canplaythrough', e => {
                        if(!loadedEvent) {
                          // ファイルロードしたので一時停止状態で待機
  
                          if(!_ua.isIE11) {
                              const result = audioPlayerObject.solo.play();
                              audioPlayerObject.solo.muted = true;
                              result.then(() => {
  
                                audioPlayerObject.solo.pause();
  
                                audioPlayerObject.solo.currentTime = 0;
                                audioPlayerObject.solo.muted = false;
                                // speedを再設定
                                audioPlayerObject.solo.speed = _playSpeed;
                                if(audioPlayerObject.solo.media) {
                                  audioPlayerObject.solo.media.playbackRate = _playSpeed;
                                  audioPlayerObject.solo.media.defaultPlaybackRate = _playSpeed;
                                }
                                playStartAudio();
  
                              });
  
                          } else {
  
                            audioPlayerObject.solo.muted = true;
                            audioPlayerObject.solo.play();
  
                            audioPlayerObject.solo.once('play', event => {
                              audioPlayerObject.solo.pause();
                            });
  
                            setTimeout(() => {
                              audioPlayerObject.solo.pause();
                              audioPlayerObject.solo.muted = false;
  
                              audioPlayerObject.solo.currentTime = 0;
                              // speedを再設定
                              audioPlayerObject.solo.speed = _playSpeed;
                              if(audioPlayerObject.solo.media) {
                                audioPlayerObject.solo.media.playbackRate = _playSpeed;
                                audioPlayerObject.solo.media.defaultPlaybackRate = _playSpeed;
                              }
                              playStartAudio();
  
                            }, 400);
                          }
  
                          L.hideLoading();
  
                          loadedEvent = true;
                          _loadedFlg = true;
  
                        }
  
                    });
                });
                audioPlayerObject.solo.on('ended', event => {
                    const callback = data.endCallback || null;
                    __endAudio(callback);
                });
  
  
                var playStartAudio = () => {
  
                    const playStart = () => {
                        if (audioPlayerObject.solo.media) {
                          setTimeout(() => {
                            audioPlayerObject.solo.play();
                          }, 300);
                        }
                        if (data.soundSync) data.soundSync();
                    };
                    if (data.waitTime !== undefined) {
                        __clearTimeout(_setWait);
                        _setWait = setTimeout(() => {
                            playStart();
                        }, data.waitTime);
                    } else {
                       playStart();
                    }
  
                };
  
            };
            _audioPlayerHandler();
  
        } else {
            if(audioPlayerObject.solo && audioPlayerObject.solo.playing) {
                audioPlayerObject.solo.stop();
            }
        }
    };
  
    /**
     * プレイ
     * 
     * @param {Object} data 
     */
    const __playAudio = data => {
        if (!_off) {
            __destoryMedia();
            __initplayAudio(data);
        }
    };
  
  
  
  
    /**
     * プレイヤー初期化Serial
     * 
     * @param {Object} data 
     */
    var __initplayAudioSerial = data => {
  
        if (data.soundPath) {
  
            _audioPlayerHandler = () => {
                L.hideLoading();
                if(!_hideloading) __loadingTimeout();
  
                const _assetsPath = `${L.getPublicPath()}assets/`;
                
                if(! (audioPlayerObject.solo && audioPlayerObject.solo.ready)) {
                    audioPlayerObject.solo = new Plyr('#audio_player', {
                        blankVideo: `${_assetsPath}images/video/blank.mp3`,
                        controls: [],
                        hideControls: true,
                        clickToPlay: false,
                        resetOnEnd: true,
                        autoplay: false,
                        autopause: true,
                        storage: { enabled: false}
                    });
                }
  
                audioPlayerObject.solo.source = {
                    type: 'audio',
                    sources: [
                        {
                            src: data.soundPath,
                            type: 'audio/mp3'
                        },
                    ]
                };
  
                // speedをデフォルトで設定
                __setSpeed();
  
                let loadedEvent = false;
  
                audioPlayerObject.solo.on('ready', event => {
  
                    audioPlayerObject.solo.on('canplaythrough', e => {
  
                        if(!loadedEvent) {
  
                          L.hideLoading();
  
                          // ファイルセットしたの一時停止状態で待機
                          audioPlayerObject.solo.pause();
  
                          loadedEvent = true;
  
                          const playStart = () => {
                              if(audioPlayerObject.solo) {
                                if (audioPlayerObject.solo.media) {
                                    audioPlayerObject.solo.play();
                                }
                                if (data.soundSync) data.soundSync(data.soundPath);
                              }
                          };
                          playStart();
                        }
                    });
                });
            };
            _audioPlayerHandler();
            return audioPlayerObject.solo;
        } else {
            if(audioPlayerObject.solo && audioPlayerObject.solo.playing) {
                audioPlayerObject.solo.stop();
            }
        }
    };
  
    /**
     * プレイSerial
     * 
     * @param {Object} data 
     */
    const __playAudioSerial = data => __initplayAudioSerial(data);
  
    /**
     * pause状態からプレイ
     */
    const __rePlayAudio = () => {
        audioPlayerObject.solo.play();
    };
  
    /**
     * pause
     */
    const __pauseAudio = () => {
        audioPlayerObject.solo.pause();
    };
  
    /**
     * 再生終了処理
     * 
     * @param {requestCallback} callback 
     */
    var __endAudio = callback => {
        // watchEnd指定があれば終了フラグを立てる
        if (_watchEnd && _watchEndnextId) {
            // クリア後にtrigger
            _watchEnd = false;
            _watchEndnextId = null;
        }
  
        if (callback) callback();
    };
  
    /**
     * 再生速度設定
     */
    var __setSpeed = speed => {
        if(speed == undefined) {
            _playSpeed = 1.0;
        } else {
            let _updateSpeed = 1.0;
            // 範囲50, 100, 150
            if(speed >= 90 && speed < 110) {
              _updateSpeed = 100;
            } else {
              if(speed >= 0 && speed < 80) {
                if(speed >= 0 && speed < 20) {
                  _updateSpeed = 50;
                } else if(speed >= 20 && speed < 40) {
                  _updateSpeed = 60;
                } else if(speed >= 40 && speed < 60) {
                  _updateSpeed = 70;
                } else if(speed >= 60 && speed < 80) {
                  _updateSpeed = 80;
                } else if(speed >= 80 && speed < 90) {
                  _updateSpeed = 100;
                }
              } else if(speed >= 110 && speed <= 200) {
                if(speed >= 110 && speed < 120) {
                  _updateSpeed = 100;
                } else if(speed >= 120 && speed < 140) {
                  _updateSpeed = 120;
                } else if(speed >= 140 && speed < 160) {
                  _updateSpeed = 130;
                } else if(speed >= 160 && speed < 180) {
                  _updateSpeed = 140;
                } else if(speed >= 180 && speed <= 200) {
                  _updateSpeed = 150;
                }
              }
            }
            _playSpeed = _updateSpeed / 100;
        }
        if(audioPlayerObject.solo) {
          audioPlayerObject.solo.speed = _playSpeed;
          if(audioPlayerObject.solo.media) {
            audioPlayerObject.solo.media.playbackRate = _playSpeed;
          }
        }
        return _playSpeed;
    };
  
    /**
     * 再生中かどうか
     */
    const __isPlaying = () => {
        if(audioPlayerObject.solo && audioPlayerObject.solo.playing) {
            return true;
        } else {
            return false;
        }
    };
  
    /**
     * 再生可能かどうか
     */
    const __isPaused = () => {
        if(audioPlayerObject.solo && audioPlayerObject.solo.ready && audioPlayerObject.solo.paused) {
            return true;
        } else {
            return false;
        }
    };
  
    // web audio api
    const __createAudio = () => {
        window.AudioContext = window.AudioContext || window.webkitAudioContext;
        audioContext = new AudioContext;
        audioGain = audioContext.createGain();
  
    };
    const __firstTouchAudio = () => {
      const audioSource  = audioContext.createBufferSource();
      const audioGain = audioContext.createGain();
  
      audioSource.buffer = c.buffer;
      audioSource.connect(audioGain);
      audioGain.connect(audioContext.destination);
      audioGain.gain.value = 0;
      audioSource.start(0);
    };
  
  
    return {
        destoryMedia: __destoryMedia,
        destoryMediaSerial: __destoryMediaSerial,
        initplayAudio: __initplayAudio,
        playAudio: __playAudio,
        playAudioSerial: __playAudioSerial,
        rePlayAudio: __rePlayAudio,
        pauseAudio: __pauseAudio,
        setSpeed: __setSpeed,
        getSpeed() { return _playSpeed; },
        isPlaying: __isPlaying,
        isPaused: __isPaused,
        audioPlayer() { return audioPlayerObject.solo; }
    };
  })();
  
  
  /**
   * Player class containing the state of our playlist and where we are in it.
   * Includes all methods for playing, skipping, updating the display, etc.
   * @param {Array} playlist Array of objects with playlist song details ({title, file, howl}).
   */
  export class audioListPlayer {
    constructor() {
      this.allplaylist = [];
      this.playlist = [];
      this.index = 0;
      this.callbackFunc = null;
      this.seekPosTime = 0;
      this.currentTime = 0;
  
      this.offsetsec = 1.01;
  
      this.autoskip = true;
  
      this.speed = 1;
  
      this.silencePlayer = null;
  
    }
  
    addPlayList(item) {
        this.playlist.push(item);
        this.allplaylist.push(item);
        audioPlayerObject.playlist.push(item);
        this.loadHowlData();
    }
  
    // 音声データの一覧をフロント側で指定してセット
    setPlaylist(listdata) {
      const self = this;
      if(self.samePlayList(listdata) == false) {

          audioPlayerObject.playlist = [];

          for(let idx in listdata) {
            audioPlayerObject.playlist.push(listdata[idx]);
          }

      }

      self.loadHowlData();

      self.allplaylist = audioPlayerObject.playlist
  
      self.index = 0;
      self.seekPosTime = 0;
      self.currentTime = 0;
      self.speed = 1;
  
      self.autoskip = true;
  
    }
  
    loadHowlData() {
      let self = this;

      if(audioPlayerObject.playlist && audioPlayerObject.playlist.length) {
        for(var plyrIdx in audioPlayerObject.playlist) {
          if(!audioPlayerObject.playlist[plyrIdx].plyr){
            self.createPlyr(plyrIdx);
          }
        }
      }
    }

    createPlyr(plyrIdx) {
      let self = this;

      const audioId = `audio_player${plyrIdx}`;

      if($('#contents').find(`#${audioId}`).length == 0) {
        $('#contents').append(`<audio id="audio_player${plyrIdx}">`);
      }

      audioPlayerObject.playlist[plyrIdx].plyr = new Plyr('#' + audioId, {
          controls: [],
          debug: false,
          hideControls: true,
          resetOnEnd: true,
          autoplay: false,
          autopause: false,
          storage: { enabled: false}
      });


      audioPlayerObject.playlist[plyrIdx].plyr.source = {
          type: 'audio',
          sources: [
              {
                  src: audioPlayerObject.playlist[plyrIdx].file,
                  type: 'audio/mp3'
              }
          ]
      };
      audioPlayerObject.playlist[plyrIdx].plyr.media.load();

      audioPlayerObject.playlist[plyrIdx].plyr.on('play', (event) => {
          if(self.callbackFunc) self.callbackFunc('play', { index: self.index });
      });

      audioPlayerObject.playlist[plyrIdx].plyr.on('ended', (event) => {
          self.seekPosTime = 0;
          let playData = audioPlayerObject.playlist[plyrIdx];

          if(playData && self.autoskip && 'stopautoskip' in playData) {
            self.skip('next');
          } else {
            if(self.callbackFunc) self.callbackFunc('autopause', { index: self.index });
          }
      });

      audioPlayerObject.playlist[plyrIdx].plyr.on('pause', (event) => {
          if(self.callbackFunc) self.callbackFunc('pause', { index: self.index });
      });

      // 差し替え時の比較用に元データとして登録
      self.allplaylist[plyrIdx] = {file: audioPlayerObject.playlist[plyrIdx].file};

    }
    
    samePlayList(newlist) {
      var self = this;
      if(self.allplaylist.length == newlist.length) {
        for(let idx1 in newlist) {
          var hasFile = false;
          for(let idx2 in self.allplaylist) {
            if(newlist[idx1].file == self.allplaylist[idx2].file) {
              hasFile = true;
              break;
            }
          }
          if(hasFile == false) {
            return false;
          }
        }
        return true;

      } else {
        return false;
      }
    }

    setCallback(callback) {
      this.callbackFunc = callback;
    }
  
    getPlayData() {
      const self = this;
      return (audioPlayerObject.playlist && audioPlayerObject.playlist.length) ? audioPlayerObject.playlist[self.index] : null;
    }
  
    /**
     * Play a song in the playlist.
     * @param  {Number} index Index of the song in the playlist (leave empty to play the first or current).
     */
    play(index) {
      const self = this;
      let sound;
  
      if(audioPlayerObject.solo && audioPlayerObject.solo.playing) {
          audioPlayerObject.solo.stop();
      }
  
      index = (index !== undefined) ? Number(index) : undefined;
  
      index = typeof index === 'number' ? index : self.index;

  
      const data = audioPlayerObject.playlist[index];

      // If we already loaded this track, use the current one.
      // Otherwise, setup and load a new Howl.
      if (data.plyr) {
        sound = data.plyr;
      } else {
        return false;
      }
  
      if(self.speed) {
        sound.speed = self.speed;
      }
      if(self.seekPosTime) {
          sound.currentTime = parseFloat(self.seekPosTime);
      }
  
      // Keep track of the index we are currently playing.
      self.index = index;
  
      sound.play();
  
    }
  
    /**
     * Pause the currently playing track.
     */
    playing() {
      const self = this;
  
      if(!audioPlayerObject.playlist || audioPlayerObject.playlist.length == 0) return false;
  
      // Get the Howl we want to manipulate.
      const sound = audioPlayerObject.playlist[self.index].plyr;
  
      // Puase the sound.
      return sound ? sound.playing : false;
    }
  
    /**
     * Pause the currently playing track.
     */
    pause() {
      const self = this;
  
      // Get the Howl we want to manipulate.
      const sound = audioPlayerObject.playlist[self.index].plyr;
  
      // Puase the sound.
      if(sound && sound.playing) sound.pause();
  
  
      if(this.callbackFunc) this.callbackFunc('pause' , { index: self.index, playlist: audioPlayerObject.playlist});
    }
  
    /**
     * Stop the currently playing track.
     */
    stop() {
      const self = this;
  
      if(!audioPlayerObject.playlist || audioPlayerObject.playlist.length == 0) return false;

  
      // Get the Howl we want to manipulate.
      const sound = audioPlayerObject.playlist[self.index].plyr;
  
      // Puase the sound.
      if(sound) sound.stop();
      if(sound) sound.currentTime = 0;
      self.index = 0;
  
      if(this.callbackFunc) this.callbackFunc('stop', { index: self.index, playlist: audioPlayerObject.playlist});
    }
  
    stopSkip() {
      const self = this;
  
      if(!audioPlayerObject.playlist || audioPlayerObject.playlist.length == 0) return false;
  
      // Get the Howl we want to manipulate.
      const sound = audioPlayerObject.playlist[self.index].plyr;
  
      // Puase the sound.
      if(sound && sound.playing) sound.stop();
      if(sound) sound.currentTime = 0;
      self.index = 0;
  
      if(this.callbackFunc) this.callbackFunc('end', { index: self.index, playlist: audioPlayerObject.playlist});
    }
  
    /**
     * Skip to the next or previous track.
     * @param  {String} direction 'next' or 'prev'.
     */
    skip(direction) {
      const self = this;
  
      // Get the next track based on the direction of the track.
      let index = 0;
      if (direction === 'prev') {
        index = self.index - 1;
        if (index < 0) {
          index = audioPlayerObject.playlist.length - 1;
        }
      } else {
        index = self.index + 1;
        if (index >= audioPlayerObject.playlist.length) {
          index = 0;
          self.index = 0;
          self.currentTime = 0;
          self.seekPosTime = 0;
          if(this.callbackFunc) this.callbackFunc('end' , { index: self.index, playlist: audioPlayerObject.playlist});
          return false;
        }
      }
  
      if(this.callbackFunc) this.callbackFunc('skip', { index: self.index, playlist: audioPlayerObject.playlist});
  
      self.skipTo(index);
    }
  
    /**
     * Skip to a specific track based on its playlist index.
     * @param  {Number} index Index in the playlist.
     */
    skipTo(index) {
      const self = this;
  
      // Stop the current track.
      if (audioPlayerObject.playlist[self.index].plyr) {
        audioPlayerObject.playlist[self.index].plyr.stop();
      }
      self.seekPosTime = 0;
  
      // start_timeの指定があればseek
      if (audioPlayerObject.playlist[self.index].start_time !== undefined) {
        self.seekTime(audioPlayerObject.playlist[self.index].start_time);
      }
  
      // Play the new track.
      self.play(index);
  
  
    }
  
    /**
     * Set the volume and update the volume slider display.
     * @param  {Number} val Volume between 0 and 1.
     */
    volume(val) {
      const self = this;
  
      // Update the global volume (affecting all Howls).
      Howler.volume(val);
    }
  
    /**
     * Set the volume and update the volume slider display.
     * @param  {Number} val Volume between 0 and 1.
     */
    mute(toggle) {
      const self = this;
  
      const soundMute = (toggle !== undefined) ? toggle : true;
  
      const sound = audioPlayerObject.playlist[self.index].plyr;
  
      // Convert the percent into a seek position.
      if (sound) {
        sound.muted = soundMute;
      }
    }
  
    /**
     * Seek to a new position in the currently playing track.
     * @param  {Number} per Percentage through the song to skip.
     */
    seek(per) {
      const self = this;
  
      // Get the Howl we want to manipulate.
      const sound = audioPlayerObject.playlist[self.index].plyr;
  
      // Convert the percent into a seek position.
      if (sound.playing) {
        sound.rewind(sound.duration() * per);
      }
    }
  
    /**
     * Seek to a new position in the currently playing track.
     * @param  {Number} per Percentage through the song to skip.
     */
    seekTime(time) {
      const self = this;
  
      // Get the Howl we want to manipulate.
      const sound = audioPlayerObject.playlist[self.index].plyr;
  
      self.seekPosTime = parseFloat(time);
  
  
      // Convert the percent into a seek position.
      if (sound) {
        if(sound.playing) {
          let seekTm = 0;
          if(audioPlayerObject.playlist.length == 1) {
            seekTm = self.seekPosTime;
          } else {
             seekTm = 0;
  
          }
          if(seekTm > 0) {
            sound.currentTime = parseFloat(seekTm);
          }
        } else {
          if(sound && self.seekPosTime > 0) {
            sound.currentTime = self.seekPosTime;
          }
        }
      }
    }
  
    /**
     * (destroy)The step called within requestAnimationFrame to update the playback position.
     */
    step() {
      const self = this;
  
      // Get the Howl we want to manipulate.
      const sound = audioPlayerObject.playlist[self.index].plyr;
  
      // Determine our current seek position.
      const seek = sound && sound.currentTime || 0;
      self.currentTime = seek;// * 1.01; // ちょい早める
  
  
    }
  
    /**
     * getCurrentTime time.
     */
    getCurrentTime() {
      const self = this;
  
      if(audioPlayerObject.playlist.length == 0) {
        return 0;
      }
      // Get the Howl we want to manipulate.
      const sound = audioPlayerObject.playlist[self.index].plyr;
  
      // Determine our current seek position.
      const seek = sound && sound.currentTime || 0;
  
      self.currentTime = seek;// * self.offsetsec; // ちょい早める
  
  
      return self.currentTime;
    }
  
    /**
     * getRestartTime time.
     */
    getRestartTime() {
      const self = this;
      return self.currentTime / self.offsetsec;
    }
  
    /**
     * getDuration time.
     */
    getDuration() {
      const self = this;
  
      if(audioPlayerObject.playlist.length == 0) return 0;
  
      // Get the Howl we want to manipulate.
      const sound = audioPlayerObject.playlist[self.index].plyr;
      if(sound) {
        return sound.duration;
      }
      return 0;
    }
  
    /**
     * getDuration time.
     */
    isFinalIndex() {
  
      const self = this;
  
      if(!audioPlayerObject.playlist || audioPlayerObject.playlist.length == 0) return true;
  
      if(self.index == (audioPlayerObject.playlist.length - 1)) {
        return true;
      }
      
      return false;
    }
  
    /**
     * Pause the currently playing track.
     */
    rate(speed) {
      const self = this;
  
      // Get the Howl we want to manipulate.
      const sound = (audioPlayerObject.playlist && audioPlayerObject.playlist.length) ? audioPlayerObject.playlist[self.index].plyr : null;
  
      self.speed = speed;
  
      if(sound) {
        sound.speed = speed;
      }
      // Puase the sound.
      return sound ? speed : false;
    }
  
    /**
     * Format the time from seconds to M:SS.
     * @param  {Number} secs Seconds to format.
     * @return {String}      Formatted time.
     */
    formatTime(secs) {
      const minutes = Math.floor(secs / 60) || 0;
      const seconds = (secs - minutes * 60) || 0;
  
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }
  
    /**
     * getRestartTime time.
     */
    getLastIndex() {
      const self = this;
      return self.index;
    }
  }
